import { render, staticRenderFns } from "./KeyShorcutInfo.vue?vue&type=template&id=391a273b&scoped=true&"
import script from "./KeyShorcutInfo.vue?vue&type=script&lang=js&"
export * from "./KeyShorcutInfo.vue?vue&type=script&lang=js&"
import style0 from "./KeyShorcutInfo.vue?vue&type=style&index=0&id=391a273b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a273b",
  null
  
)

export default component.exports